import { SVGProps } from 'react';

export type SlashIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const SlashIcon = ({ color = '#242424', ...props }: SlashIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0508 2.6543H13.5352L8.98438 17H7.5L12.0508 2.6543Z" fill={color} />
  </svg>
);
